import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'
import Icons from '@olxbr/olx-icons'

const Container = styled(View)`
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin: 0;
`

const SessionCard = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-left: 0;
  margin-right: 0;
  position: relative;
  &:hover {
    background-color: #f6f6f6;
    a {
      color: #6e0ad6;
    }
  }
`

const SessionInfo = styled(View)`
  display: flex;
  flex-direction: column;
`

const DeviceIcon = styled(View)`
  margin-right: 10px;
`

const DeviceName = styled(Text)`
  font-size: 14px;
  font-weight: 700;
  color: #4b4b4b;
`

const SessionData = styled(Text)`
  font-size: 12px;
  font-weight: 500;
  color: #838383;
`

const SessionActive = styled(SessionData)`
  color: #10ce63;
`

class LoginHistory extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sessions: props.sessions,
    }
  }

  deviceIcon = type => {
    const iconType = {
      pc: <Icons.System.Monitor color="#4a4a4a" size={32} />,
      mobile: <Icons.System.Smartphone color="#4a4a4a" size={32} />,
    }
    return iconType[type]
  }

  renderHistory = sessions => {
    return sessions.map(session => (
      <SessionCard key={session.id}>
        <DeviceIcon>{this.deviceIcon(session.deviceName)}</DeviceIcon>
        <SessionInfo>
          <DeviceName>{session.deviceType}</DeviceName>

          <SessionData>
            {session.location} -{' '}
            {session.lastActivityAge === 'agora' ? (
              <SessionActive>{session.lastActivityAge}</SessionActive>
            ) : (
              <SessionData>{session.lastActivityAge}</SessionData>
            )}
          </SessionData>
        </SessionInfo>
      </SessionCard>
    ))
  }

  render() {
    const { sessions } = this.state
    return <Container>{sessions ? this.renderHistory(sessions) : []}</Container>
  }
}

LoginHistory.propTypes = {
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      deviceType: PropTypes.string.isRequired,
      deviceName: PropTypes.oneOf(['pc', 'mobile']).isRequired,
      location: PropTypes.string.isRequired,
      lastActivityAge: PropTypes.string.isRequired,
    })
  ),
}

export default LoginHistory
